import styled from "styled-components";

export const TeamRosterAddPanel = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px dashed var(--brand-border);
  border-radius: 1.25rem;
  padding: 1rem;
`;

export const TeamRosterAddHeader = styled.div.attrs({
  className: "space-y-2",
})``;

export const TeamRosterAddTitle = styled.p.attrs({
  className: "text-sm font-semibold text-[var(--brand-ink)]",
})``;

export const TeamRosterAddScopeRow = styled.div.attrs({
  className: "flex flex-wrap items-center gap-2",
})``;

export const TeamRosterAddScopeChip = styled.span<{ $tone: "team" | "school" | "sport" }>`
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25;
  padding: 0.3rem 0.65rem;

  ${({ $tone }) =>
    $tone === "team"
      ? `
    background: rgba(240, 191, 86, 0.14);
    border-color: rgba(240, 191, 86, 0.28);
    color: var(--brand-highlight);
  `
      : $tone === "school"
        ? `
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.1);
    color: var(--brand-ink);
  `
        : `
    background: rgba(120, 167, 222, 0.12);
    border-color: rgba(120, 167, 222, 0.24);
    color: #9ec5ef;
  `}
`;

export const TeamRosterAddDescription = styled.p.attrs({
  className: "text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const TeamRosterAddToolbar = styled.div.attrs({
  className: "mt-4 flex flex-col gap-3 sm:flex-row sm:items-end",
})``;

export const TeamRosterAddSelectField = styled.div.attrs({
  className: "min-w-0 flex-1",
})``;

export const TeamRosterAddFieldLabel = styled.label.attrs({
  className: "mb-2 block text-xs uppercase tracking-[0.16em] text-[var(--brand-muted)]",
})``;

export const TeamRosterAddEmptyText = styled.p.attrs({
  className: "mt-3 text-sm leading-6 text-[var(--brand-muted)]",
})``;
